import { useQuery } from '@tanstack/react-query';
import { fetchDeployDiagnostics, type DeployDiagnostics } from '../../lib/buildInfo';
import { queryKeys } from './queryKeys';

type DeployDiagnosticsOptions = {
  enabled?: boolean;
};

export const useDeployDiagnostics = (options: DeployDiagnosticsOptions = {}) => {
  return useQuery<DeployDiagnostics>({
    queryKey: queryKeys.deployDiagnostics.all,
    queryFn: fetchDeployDiagnostics,
    enabled: options.enabled ?? true,
    staleTime: 30_000,
  });
};
